import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-092054cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "项目地址")
], -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "label-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "项目类别")
], -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "label-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "资金来源")
], -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "label-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "项目规模")
], -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "label-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "联系人姓名")
], -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "label-title" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "联系人电话")
], -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "label-title" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "工程类型")
], -1))
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "label-title" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "经营方式")
], -1))
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "label-title" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "考察说明")
], -1))
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "label-title" }

import { onMounted, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const details = ref({})
onMounted(() => {
  let detail = JSON.parse(localStorage.getItem('PROJECT_DETAIL'))
  details.value = detail
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell, {
          title: "项目名称",
          value: details.value.name
        }, null, 8, ["value"])
      ]),
      _: 1
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell, null, {
            title: _withCtx(() => [
              _hoisted_4
            ]),
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(details.value.area_name) + _toDisplayString(details.value.address), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { class: "van-cell-down" }, {
            title: _withCtx(() => [
              _hoisted_7
            ]),
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(details.value.declare_type_name), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { class: "van-cell-down" }, {
            title: _withCtx(() => [
              _hoisted_10
            ]),
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(details.value.capital_source_desc), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { class: "van-cell-down" }, {
            title: _withCtx(() => [
              _hoisted_13
            ]),
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(details.value.project_size), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { class: "van-cell-down" }, {
            title: _withCtx(() => [
              _hoisted_16
            ]),
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(details.value.contact_name), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { class: "van-cell-down" }, {
            title: _withCtx(() => [
              _hoisted_19
            ]),
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(details.value.contact_phone), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { class: "van-cell-down" }, {
            title: _withCtx(() => [
              _hoisted_22
            ]),
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(details.value.project_type_descs === 1 ? '新建' : '改造'), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { class: "van-cell-down" }, {
            title: _withCtx(() => [
              _hoisted_25
            ]),
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(details.value.mode_operation_desc || '暂无'), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_cell, { class: "van-cell-down" }, {
            title: _withCtx(() => [
              _hoisted_28
            ]),
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(details.value.inspection_instructions), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})